module.exports = __webpack_public_path__ + "img/curriculumfooter.aa8456e2.png";